var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRestart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 -960 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M445.282-142.771q-113.358-12.307-189.319-97.051-75.962-84.743-75.962-199.768 0-66.281 28.744-125.755 28.743-59.475 79.974-100.962l35.742 35.999q-45.512 33.206-69.859 83.654-24.346 50.449-24.346 107.064 0 93.949 61.064 163.705 61.065 69.757 153.962 82.859v50.255Zm70.256.77v-50.255q92.975-15.385 153.795-84.577 60.821-69.193 60.821-162.757 0-104.461-72.641-177.102T480.41-689.333h-22.411l61.847 61.847-35.794 35.793-122.768-122.768 122.768-122.768 35.794 35.794-61.847 61.847h22.411q125.538 0 212.768 87.563 87.231 87.564 87.231 212.435 0 114.82-75.82 199.307t-189.051 98.282Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestart);
export default __webpack_public_path__ + "static/media/restart.3df5e54ef243682c5837cf7632d0c3ce.svg";
export { ForwardRef as ReactComponent };